import { React, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
  //layout
  WithOutSideBarLayout,
  LogoImageLayout,

  //style
  TitleTextStyle,
  StyledBlueButton,
  TextTitle3,
  TextHeading3,
} from "common/components";
import { useLocation, useNavigate } from "react-router";
import { apiRequest, useApiRequest } from "common/utils/api";
import { useTranslation } from "react-i18next";
import { TextInput } from "common/components/Input/TextInput";
import { DefaultButton } from "common/components/Button/new/DefaultButton";
import { colors } from "common/const/colors";
import { buttonHeight } from "common/const/const";
import { REQUEST_METHOD } from "common/enum/RequestMethod";
import { PopUpScreen } from "common/views";
import { showMessageModal } from "common/utils/modalController";
import { I18N_KEYS } from "common/i18n/keys";
import { Column } from "common/components/Layout/new/constLayout";
import { IconWrapper, ViewIcon, ViewOffIcon } from "common/components/icon";
import { Direction } from "common/enum/direction";

const VerifyPasswordScreen = () => {
  const { t } = useTranslation();
  const methods = useForm({
    mode: "onBlur",
    defaultValues: {
      email: "",
      password: "",
    },
  });
  const [failPopUp, setFailPopUp] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const [showPassword, setShowPassword] = useState(false);

  useApiRequest({
    method: REQUEST_METHOD.GET,
    url: "/api/v1.0/users",
    onSuccess: (data) => {
      methods.reset({
        email: data.result.email,
        password: "",
      });
    },
    onError: (error) => {
      console.error(error);
    },
  });

  const onSubmit = methods.handleSubmit(async (data) => {
    try {
      const response = await apiRequest({
        method: REQUEST_METHOD.POST,
        url: "/api/v1.0/sign-in",
        body: data,
        noRedirect: true,
      });
      navigate(location.state?.nextPage || -1, {
        state: { success: true },
        replace: true,
      });
    } catch (error) {
      console.log(error);
      showMessageModal(t(I18N_KEYS.verifyPassword.message.failed));
      setFailPopUp(true);
    } finally {
      methods.reset({ email: data.email, password: "" });
    }
  });

  return (
    <WithOutSideBarLayout>
      <LogoImageLayout>
        <Column gap={"4rem"}>
          <Column gap={"2.5rem"} $align={"center"}>
            <img src={require("assets/logo/logo.png")} alt="logo" />
            <TextHeading3>{t(I18N_KEYS.verifyPassword.title)}</TextHeading3>
          </Column>
          <FormProvider {...methods}>
            <TextInput
              name="password"
              type="password"
              placeholder={t(
                I18N_KEYS.verifyPassword.form.placeholder.password,
              )}
              rules={{
                required: {
                  value: true,
                  message: t("login.text005"),
                },
                minLength: {
                  value: 8,
                  message: t("login.text008"),
                },
              }}
              icon={{
                element: (
                  <IconWrapper
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowPassword(!showPassword);
                    }}>
                    {showPassword ? (
                      <ViewOffIcon color={colors.LightNavy} />
                    ) : (
                      <ViewIcon color={colors.LightNavy} />
                    )}
                  </IconWrapper>
                ),
                position: Direction.RIGHT,
              }}
            />
            <DefaultButton.Blue
              height={buttonHeight}
              text={t(I18N_KEYS.verifyPassword.form.submit)}
              onClick={onSubmit}
              disabled={
                !methods.formState.isValid || methods.formState.isSubmitting
              }
            />
          </FormProvider>
        </Column>
      </LogoImageLayout>
    </WithOutSideBarLayout>
  );
};

export default VerifyPasswordScreen;
